import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import {Check, X, Star, Dumbbell, Clock, MapPin} from 'lucide-react';

const Pricing = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0 bg-gradient-to-br from-black via-zinc-900 to-black">
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: 'radial-gradient(circle, #E31E24 1px, transparent 1px)',
            backgroundSize: '50px 50px'
          }} />
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tighter italic">
            TARIFS <span className="text-nolimit-red">MENSUELS</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Des formules adaptées à tous les budgets et tous les objectifs
          </p>
        </div>
      </section>

      {/* Avantages Tarifaires */}
      <section className="py-16 bg-black border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: <X className="h-6 w-6" />, text: "Sans frais d'adhésion" },
              { icon: <Clock className="h-6 w-6" />, text: "Ouvert 7j/7 de 6h à 23h" },
              { icon: <MapPin className="h-6 w-6" />, text: "Parking gratuit" }
            ].map((item, idx) => (
              <div key={idx} className="flex items-center space-x-3 bg-zinc-900 p-4 rounded-xl border border-white/5">
                <div className="text-nolimit-red shrink-0">{item.icon}</div>
                <p className="text-gray-200 font-medium text-sm">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Annuel */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-4xl font-black text-white mb-4 italic">
              ENGAGEMENT <span className="text-nolimit-red">ANNUEL</span>
            </h2>
            <p className="text-gray-400">Les meilleurs tarifs pour un engagement sur 12 mois</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cardio - Musculation */}
            <div className="bg-zinc-900 rounded-2xl border border-white/10 p-8 hover:border-nolimit-red/50 transition-all">
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                <h3 className="text-2xl font-black text-white mb-2">CARDIO - MUSCULATION</h3>
                <p className="text-gray-400 text-sm">Engagement 12 mois</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-white">30</span>
                  <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Zone musculation complète",
                  "Espace cardio-training",
                  "Parking gratuit"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-gray-300">
                    <Check className="h-5 w-5 text-nolimit-red mr-3 shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <Button variant="outline" className="w-full">Choisir</Button>
              </Link>
            </div>

            {/* Cours Collectifs */}
            <div className="bg-zinc-900 rounded-2xl border border-white/10 p-8 hover:border-nolimit-red/50 transition-all">
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                <h3 className="text-2xl font-black text-white mb-2">COURS COLLECTIFS</h3>
                <p className="text-gray-400 text-sm">Engagement 12 mois</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-white">32</span>
                  <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Tous les cours collectifs",
                  "Planning varié",
                  "Parking gratuit"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-gray-300">
                    <Check className="h-5 w-5 text-nolimit-red mr-3 shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <Button variant="outline" className="w-full">Choisir</Button>
              </Link>
            </div>

            {/* Formule Complète - POPULAIRE */}
            <div className="bg-gradient-to-br from-nolimit-red to-red-700 rounded-2xl border-2 border-nolimit-red p-8 relative transform lg:scale-105 shadow-2xl">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-black text-nolimit-red px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider border border-nolimit-red">
                Le plus populaire
              </div>
              
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-black mb-4" />
                <h3 className="text-xl font-black text-black mb-2">CARDIO - MUSCULATION + COURS</h3>
                <p className="text-black/80 text-sm font-bold">Engagement 12 mois</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-black">36</span>
                  <span className="text-2xl text-black/80 ml-2 font-bold">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Musculation complète",
                  "Cardio-training",
                  "Tous les cours collectifs",
                  "Parking gratuit"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-black">
                    <Check className="h-5 w-5 text-black mr-3 shrink-0 mt-0.5 font-bold" />
                    <span className="text-sm font-bold">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <button className="w-full bg-black text-white hover:bg-zinc-900 px-6 py-3 rounded-full font-bold transition-all transform hover:scale-105">
                  Choisir
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Sans Engagement */}
      <section className="py-20 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-4xl font-black text-white mb-4 italic">
              SANS <span className="text-nolimit-red">ENGAGEMENT</span>
            </h2>
            <p className="text-gray-400">Formule sans frais et sans préavis</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cardio - Musculation */}
            <div className="bg-black rounded-2xl border border-white/10 p-8 hover:border-nolimit-red/50 transition-all">
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                <h3 className="text-2xl font-black text-white mb-2">CARDIO - MUSCULATION</h3>
                <p className="text-gray-400 text-sm">Sans engagement</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-white">36</span>
                  <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Zone musculation complète",
                  "Espace cardio-training",
                  "Parking gratuit",
                  "Résiliation à tout moment"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-gray-300">
                    <Check className="h-5 w-5 text-nolimit-red mr-3 shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <Button variant="outline" className="w-full">Choisir</Button>
              </Link>
            </div>

            {/* Cours Collectifs */}
            <div className="bg-black rounded-2xl border border-white/10 p-8 hover:border-nolimit-red/50 transition-all">
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                <h3 className="text-2xl font-black text-white mb-2">COURS COLLECTIFS</h3>
                <p className="text-gray-400 text-sm">Sans engagement</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-white">38</span>
                  <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Tous les cours collectifs",
                  "Planning varié",
                  "Parking gratuit",
                  "Résiliation à tout moment"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-gray-300">
                    <Check className="h-5 w-5 text-nolimit-red mr-3 shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <Button variant="outline" className="w-full">Choisir</Button>
              </Link>
            </div>

            {/* Formule Complète */}
            <div className="bg-black rounded-2xl border border-nolimit-red/50 p-8 hover:border-nolimit-red transition-all">
              <div className="mb-6">
                <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                <h3 className="text-xl font-black text-white mb-2">CARDIO - MUSCULATION + COURS</h3>
                <p className="text-gray-400 text-sm">Sans engagement</p>
              </div>
              
              <div className="mb-8">
                <div className="flex items-baseline mb-2">
                  <span className="text-5xl font-black text-white">42</span>
                  <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  "Accès illimité 7j/7",
                  "Musculation complète",
                  "Cardio-training",
                  "Tous les cours collectifs",
                  "Parking gratuit",
                  "Résiliation à tout moment"
                ].map((feature, i) => (
                  <li key={i} className="flex items-start text-gray-300">
                    <Check className="h-5 w-5 text-nolimit-red mr-3 shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/contact">
                <Button variant="outline" className="w-full">Choisir</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Tarif Étudiant */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <Star className="h-16 w-16 text-nolimit-red mx-auto mb-6" />
            <h2 className="text-4xl font-black text-white mb-4 italic">
              TARIF <span className="text-nolimit-red">ÉTUDIANT*</span>
            </h2>
            <p className="text-gray-400 text-sm">*Tarif applicable pour les moins de 25 ans, sur présentation d'une attestation de scolarité ou d'une carte d'étudiant en cours de validité</p>
          </div>
          
          {/* Étudiant Engagement Annuel */}
          <div className="mb-16">
            <h3 className="text-2xl font-black text-white mb-8 text-center">ENGAGEMENT ANNUEL</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { title: "CARDIO - MUSCULATION", price: "25,50" },
                { title: "COURS COLLECTIFS", price: "25,50" },
                { title: "CARDIO - MUSCULATION + COURS", price: "32,50", popular: true }
              ].map((plan, idx) => (
                <div key={idx} className={`rounded-2xl border p-8 hover:border-nolimit-red/50 transition-all ${
                  plan.popular ? 'bg-zinc-900 border-nolimit-red/50' : 'bg-zinc-900 border-white/10'
                }`}>
                  <div className="mb-6">
                    <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                    <h4 className="text-xl font-black text-white mb-2">{plan.title}</h4>
                    <p className="text-gray-400 text-sm">Engagement 12 mois</p>
                  </div>
                  
                  <div className="mb-8">
                    <div className="flex items-baseline mb-2">
                      <span className="text-5xl font-black text-white">{plan.price}</span>
                      <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                    </div>
                  </div>

                  <Link to="/contact">
                    <Button variant="outline" className="w-full">Choisir</Button>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Étudiant Sans Engagement */}
          <div>
            <h3 className="text-2xl font-black text-white mb-8 text-center">SANS ENGAGEMENT</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                { title: "CARDIO - MUSCULATION", price: "29,50" },
                { title: "COURS COLLECTIFS", price: "29,50" },
                { title: "CARDIO - MUSCULATION + COURS", price: "36,50", popular: true }
              ].map((plan, idx) => (
                <div key={idx} className={`rounded-2xl border p-8 hover:border-nolimit-red/50 transition-all ${
                  plan.popular ? 'bg-zinc-900 border-nolimit-red/50' : 'bg-zinc-900 border-white/10'
                }`}>
                  <div className="mb-6">
                    <Dumbbell className="h-10 w-10 text-nolimit-red mb-4" />
                    <h4 className="text-xl font-black text-white mb-2">{plan.title}</h4>
                    <p className="text-gray-400 text-sm">Sans engagement</p>
                  </div>
                  
                  <div className="mb-8">
                    <div className="flex items-baseline mb-2">
                      <span className="text-5xl font-black text-white">{plan.price}</span>
                      <span className="text-2xl text-gray-400 ml-2">€/mois</span>
                    </div>
                  </div>

                  <Link to="/contact">
                    <Button variant="outline" className="w-full">Choisir</Button>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-nolimit-red">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-black text-black mb-6 italic uppercase">
            Contactez-nous !
          </h2>
          <p className="text-xl text-white/90 mb-10 font-medium">
            Des questions sur nos tarifs ? Besoin d'un devis personnalisé ? Notre équipe est à votre écoute.
          </p>
          <Link to="/contact">
            <button className="bg-white text-nolimit-red hover:bg-gray-100 px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl">
              NOUS CONTACTER
            </button>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Pricing;